export const parseArray = (value: string): any[] => {
  let data = []
  if (!value) {
    return []
  }
  try {
    data = JSON.parse(value)
  } catch {}
  return data
}

export function parseObject<T = IObjectAny>(value: string): T {
  let data = {} as T
  if (!value) {
    return data
  }
  try {
    data = JSON.parse(value) as T
  } catch {}
  return data as T
}

export const parseJson = <T>(value: string, exitOnError?: boolean): T | null => {
  let parsed = null
  try {
    parsed = JSON.parse(value)
  } catch (e: any) {
    if (exitOnError) {
      throw new Error(`JSON parse Error. Value for parse: ${value}`)
    }
  }
  return parsed
}

/**
 * Parse step fields for BP or APL registration
 * @param fields Object || string[]
 * @returns string[]
 */
export const parseStepFields = (fields: any) => {
  if (Array.isArray(fields)) {
    return fields
  } else if (typeof fields === 'object') {
    return Object.values(fields).flat()
  } else {
    return []
  }
}
